// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 1.5L10 4.83333V10H22V22H18.5V16H11.5V22H2V1.5ZM8 20V6.16667L4 4.5V20H8Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M16.5 22H13.5V18H16.5V22Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-city-filled')
export default class CityFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-filled',
    }
  }
}
